import { supabase } from "./supabaseClient";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export async function checkSignupEmail(email) {
  let response;
  try {
    response = await fetch(`${API}/public/signup-email-status?email=${encodeURIComponent(email)}`);
  } catch {
    return { ok: false, message: "Could not check this email. Please try again.", actions: [] };
  }
  if (response.ok) return { ok: true };
  const payload = await response.json().catch(() => ({}));
  const detail = payload.detail || {};
  return {
    ok: false,
    code: detail.code,
    message: detail.message || "Could not check this email. Please try again.",
    actions: detail.actions || [],
  };
}

// Fetch wrapper that attaches the current Supabase access token.
export async function authedFetch(path, options = {}) {
  let { data: { session } } = await supabase.auth.getSession();
  if (!session?.access_token) {
    const { data } = await supabase.auth.refreshSession();
    session = data?.session || null;
  }
  const token = session?.access_token;
  if (!token) {
    return new Response(JSON.stringify({ detail: "Your session has expired. Please sign in again, then retry the action." }), {
      status: 401,
      headers: { "Content-Type": "application/json" },
    });
  }
  let res = await fetch(`${API}${path}`, {
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...(options.headers || {}),
      Authorization: `Bearer ${token}`,
    },
  });
  if (res.status === 401) {
    const { data } = await supabase.auth.refreshSession();
    const refreshedToken = data?.session?.access_token;
    if (refreshedToken && refreshedToken !== token) {
      res = await fetch(`${API}${path}`, {
        ...options,
        headers: {
          "Content-Type": "application/json",
          ...(options.headers || {}),
          Authorization: `Bearer ${refreshedToken}`,
        },
      });
    }
  }
  return res;
}

// Days remaining until an ISO date (negative if already past).
export function daysUntil(iso) {
  if (!iso) return null;
  const ms = new Date(iso).getTime() - Date.now();
  return Math.ceil(ms / (1000 * 60 * 60 * 24));
}

// Always turn an error (string, AuthError object, or FastAPI 422 detail array) into a readable message.
export function errText(e, fallback = "Something went wrong. Please try again.") {
  if (e == null) return fallback;
  if (typeof e === "string") return e.trim() || fallback;
  if (Array.isArray(e)) {
    const parts = e.map((x) => (typeof x === "string" ? x : x?.msg || x?.message || "")).filter(Boolean);
    return parts.length ? parts.join("; ") : fallback;
  }
  if (typeof e === "object") {
    if (Array.isArray(e.detail)) return errText(e.detail, fallback);
    return e.message || (typeof e.detail === "string" ? e.detail : "") || e.error_description || e.error || e.msg || fallback;
  }
  return String(e) || fallback;
}
